/**
 * `wpp::form.segment-control` and `wpp::form.radio-group`
 *
 * The selected value, held here so that clicking a segment repaints immediately
 * rather than after a round trip. Entangled with Livewire by the markup when a
 * `wire:model` is given.
 *
 * @param {{ selected?: string|number|null }} options
 */
export default (options = {}) => ({
    selected: options.selected ?? null,

    select(value) {
        this.selected = value;
    },

    /**
     * Compared as strings, because the two sides arrive in different types.
     *
     * The markup always names an option by string — it is an HTML attribute —
     * while an entangled Livewire property keeps its PHP type, so an `int`
     * property holding `1` never matched the option `'1'` and nothing showed as
     * selected. Strings rather than `==`, which would also call `0` and `''`
     * the same choice. Nothing selected matches nothing.
     */
    isSelected(value) {
        if (this.selected === null || this.selected === undefined) {
            return false;
        }

        return String(this.selected) === String(value);
    },
});
